import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {TimeDelta} from '../../models/TimeDelta';
import { Router, ActivatedRoute } from '@angular/router';


@Component({
  selector: 'vc-poll-planned-countdown',
  templateUrl: 'poll-planned-countdown.component.html',
  styleUrls: ['./poll-planned-countdown.component.less', '../../shared/common.less']
})

export class PollPlannedCountdownComponent implements OnInit {
  @Input() timeDelta: TimeDelta;
  @Input() days: number;
  @Input() hours: number;
  @Input() minutes: number;
  @Input() seconds: number;
  @Input() hasAssessorsButtons: boolean;
  @Input() canSendConvocations: boolean;
  @Input() canResendAssessors: boolean;
  @Input() inactiveAssessors: number;
  @Input() assessorCount: number;
  @Input() opened: boolean;
  @Input() votersVoted: number;
  @Input() votersCount: number;
  @Output() shouldLaunchConvocations = new EventEmitter<boolean>();
  @Output() shouldGetAssessors = new EventEmitter<boolean>();
  @Output() shouldRelaunchAssessors = new EventEmitter<boolean>();
  @Output() refreshDataEvent = new EventEmitter<boolean>();
  @Input() timeDiffHours: number;
  @Input() remainingAssessorTime: string;
  @Input() title: string;
  @Input() suspended: boolean;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) {
  }

  navigateToAudit() {
    this.route.params
      .subscribe(params => {
        this.router.navigate(['/poll-audit/' + params['id']])
      });
  }

  launchConvocations() {
    this.shouldLaunchConvocations.emit(true);
  }

  relaunchAssessors() {
    this.shouldRelaunchAssessors.emit(true);
  }

  getInactiveAssessors() {
    this.shouldGetAssessors.emit(true);
  }

  refresh() {
    this.refreshDataEvent.emit(true);
  }

  ngOnInit() {
  }
}
